<template>
  <div v-if="campaign" class="max-w-7xl mx-auto py-6 px-4 sm:px-6">
    <div class="flex justify-between">
      <h2 class="text-xl sm:text-2xl font-semibold tracking-tight text-blue-dark">Conference Support</h2>
    </div>
    <div class="mt-2 bg-white p-2 rounded-lg flex">
      <div class="w-1/3 hidden md:block">
        <img src="https://pslive.blob.core.windows.net/images/event/bfb-2026-thumb.jpg" class="w-full rounded-md" />
      </div>
      <div class="w-full md:w-3/4 md:pl-4 pt-2 lg:pt-4 lg:pr-4">
        <div class="flex justify-between pb-4">
          <a class="font-bold text-lg hover:underline" href="https://donate.stripe.com/3cIaEY899evN1Zzg3adQQ0c">
            {{ campaign.title }}
          </a>
          <div class="flex-none pt-2">
            <a class="bg-blue hover:bg-blue-dark rounded-md px-6 py-3 text-md font-semibold text-white" href="https://donate.stripe.com/3cIaEY899evN1Zzg3adQQ0c">
              Donate Now
            </a>
          </div>
        </div>
        <div class="overflow-hidden rounded-full bg-gray-200 mt-2 lg:mt-4">
          <div class="h-2 rounded-full bg-blue" :style="{ width: progressPercent + '%' }" />
        </div>
        <div class="flex justify-between my-2 lg:my-4">
          <div class="mr-6">
            <div class="text-lg font-bold">{{ raisedDisplay }}</div>
            <div>Raised</div>
          </div>
          <div>
            <div class="text-lg font-bold text-right">{{ targetDisplay }}</div>
            <div class="text-right">Total Goal</div>
          </div>
        </div>
        <div class="flex justify-center my-2 lg:my-4">
          <div class="text-sm text-gray-500 mt-2 text-center">Due By: {{ campaign.due }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useCampaigns } from '@/composables/useCampaigns'

const CAMPAIGN_ID = 'mx4n8g0a75c5l6l'

export default defineComponent({
  name: 'SectionSupport',
  setup () {
    const { getCampaignById } = useCampaigns()
    const campaignState = getCampaignById(CAMPAIGN_ID)
    const campaign = computed(() => campaignState.result)

    const toMajorCurrency = (price) => {
      const value = Number(price)
      if (!Number.isFinite(value)) {
        return 0
      }

      return value / 100
    }

    const getCurrencyCode = (currencyCode) => {
      const normalized = String(currencyCode || '').toUpperCase()
      if (normalized === 'GBP' || normalized === 'GPB') {
        return 'GBP'
      }

      return normalized || 'GBP'
    }

    const formatMoney = (amount, currencyCode) => {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: getCurrencyCode(currencyCode),
        maximumFractionDigits: 0
      }).format(amount)
    }

    const raisedAmount = computed(() => {
      return toMajorCurrency(campaign.value?.expand?.raised?.price)
    })

    const targetAmount = computed(() => {
      return toMajorCurrency(campaign.value?.expand?.target?.price)
    })

    const raisedDisplay = computed(() => {
      return formatMoney(raisedAmount.value, campaign.value?.expand?.raised?.currency)
    })

    const targetDisplay = computed(() => {
      return formatMoney(targetAmount.value, campaign.value?.expand?.target?.currency)
    })

    const progressPercent = computed(() => {
      if (!targetAmount.value) {
        return 0
      }

      const ratio = (raisedAmount.value / targetAmount.value) * 100
      return Math.max(0, Math.min(100, Math.round(ratio)))
    })

    return {
      campaign,
      raisedDisplay,
      targetDisplay,
      progressPercent
    }
  }
})
</script>
